<template>
    <div class="comment__text"
         v-html="text"
         :class="cssClasses">
    </div>
</template>

<script>
    import {isCommentShowing} from "VueApps/comments/services/commentStatusResolver";
    import twemoji from 'twemoji';

    export default {
        name: "CommentText",
        props: {
            comment: {
                type: Object,
                required: true
            }
        },
        computed: {
            isCommentShowing: function () {
                return isCommentShowing(this.comment);
            },
            text: function () {
                return this.isCommentShowing ?
                    twemoji.parse(this.comment.text) :
                    this.comment.status.reason;
            },
            highlightComment: function () {
                const highlightCommentId = this.$store.state.highlightCommentId;

                return null !== highlightCommentId && this.comment.id === highlightCommentId;
            },
            cssClasses: function() {
                return {
                    'comment__text--not-showing': !this.isCommentShowing,
                    'comment__text--active': this.highlightComment
                }
            }
        }
    }
</script>

<style scoped>

</style>
